import { useState } from 'react';
import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import QuestionIcon from '@/shared/icons/QuestionIcon';
import BookIcon from '@/shared/icons/BookIcon';
import DiscordIcon from '@/shared/icons/DiscordIcon';
import EmailIcon from '@/shared/icons/EmailIcon';
import IconWrapper from '@/shared/components/UI/IconWrapper';
import mixpanel from '@/utils/mixpanel';

const HeaderLearningHub = () => {
  const [emailCopied, setEmailCopied] = useState(false);

  
  const handleEmailUs = async () => {
    const email = 'hello@dante-ai.com';
    await navigator.clipboard.writeText(email);
    setEmailCopied(true);
    setTimeout(() => setEmailCopied(false), 2000);
    window.open(`mailto:${email}`, '_blank');
  };

  return (
    <Menu>
      {({ open }) => (
        <>

           <MenuButton onClick={() => { if (!open) mixpanel.track('Learning Hub Opened'); }} className="inline-flex items-center justify-center gap-2 font-semibold text-black  focus:outline-none data-[hover]:bg-v3-gray-light rounded-v3-xs data-[open]:bg-grey-5 data-[focus]:outline-1 data-[focus]:outline-black inset-1 !w-v3-lg !h-v3-lg hover:bg-v3-menu-hover">
            <IconWrapper size={20}>
              <QuestionIcon className="w-full h-full text-v3-purple-primary" />
            </IconWrapper>
          </MenuButton>
          <MenuItems
            transition
            anchor="bottom end"
            className="w-[323px] mt-[12px] rounded-v3-sm border border-v3-card-border shadow-v3-card bg-white   text-v3-black-max font-inter-variable transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 z-20"
          >
            <button className="dbutton group w-full text-left py-v3-xs  px-v3-sm gap-v3-xs  flex items-center" onClick={() => { mixpanel.track('Learning Hub Link Clicked', { link_type: 'email' }); handleEmailUs(); }}>

              <IconWrapper size={20}>
                <EmailIcon className='text-v3-black-max w-full h-full group-hover:text-v3-purple-primary'/>
              </IconWrapper>

             <p className='text-v3-black-max text-v3-h9 font-medium group-hover:text-v3-purple-primary '>{emailCopied ? 'Email Copied!' : 'Email Us'}</p>
            </button>
            <button className="dbutton group w-full text-left py-v3-xs  px-v3-sm gap-v3-xs  flex items-center " onClick={() => { mixpanel.track('Learning Hub Link Clicked', { link_type: 'guide' }); window.open('https://www.dante-ai.com/guides', '_blank'); }}>

               <IconWrapper size={20}>
                <BookIcon className='text-v3-black-max h-full w-full group-hover:text-v3-purple-primary'/>
              </IconWrapper>

             <p className='text-v3-black-max text-v3-h9 font-medium group-hover:text-v3-purple-primary'>See User Guide</p>
            </button>
            <button className="dbutton group w-full text-left py-v3-xs  px-v3-sm   gap-v3-xs flex items-center" onClick={() => { mixpanel.track('Learning Hub Link Clicked', { link_type: 'discord' }); window.open('https://discord.com/invite/sEe4yUY8BM', '_blank'); }}>

              <IconWrapper size={20}>
                <DiscordIcon className='text-v3-black-max w-full h-full group-hover:text-v3-purple-primary'/>
              </IconWrapper>

             <p className='text-v3-black-max text-v3-h9 font-medium group-hover:text-v3-purple-primary'>Join Our Discord Community</p>
            </button>
          </MenuItems>
        </>
      )}
    </Menu>
  );
};

export default HeaderLearningHub;
